/** Metadatos de la aplicación (una sola empresa, sin multi-tenant en fase 1). */
export const appConfig = {
  name: 'ERP ASAP',
  domain: 'erp.asap.is',
  companyId: 'default',
  locale: 'es-AR',
  currency: 'ARS',
} as const;
